import React from 'react';
import { motion } from 'framer-motion';
import { Download, PlayCircle, MessageCircle, ShieldCheck } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <Download className="w-8 h-8 text-brand-gold" data-id="element-72" />,
    title: 'Descarga el Plan',
    desc: 'Recibes el acceso inmediato a los archivos PDF tras el pago.'
  }, {
    icon: <PlayCircle className="w-8 h-8 text-brand-gold" data-id="element-73" />,
    title: 'Aplica los 7 Días',
    desc: 'Sigue una tarea diaria sencilla (máximo 45 min por día).'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-brand-gold" data-id="element-74" />,
    title: 'Recibe Prospectos',
    desc: "Mira cómo tu bandeja de entrada empieza a llenarse de personas preguntando: '¿De qué trata tu proyecto?'."
  }];
  return <section className="bg-brand-dark px-6 py-20 md:py-28" data-id="element-75">
      <div className="mx-auto max-w-5xl" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-78">
            ¿Cómo Funciona?
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-79"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24" data-id="element-80">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-brand-darker border border-slate-800 rounded-2xl p-8 text-center relative" data-id="element-81">
              <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-12 h-12 bg-brand-light border-2 border-brand-gold rounded-full flex items-center justify-center text-brand-gold font-bold text-xl" data-id="element-82">
                {index + 1}
              </div>
              <div className="flex justify-center mb-6 mt-4" data-id="element-83">
                <div className="p-4 bg-brand-gold/10 rounded-full" data-id="element-84">
                  {step.icon}
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-85">
                {step.title}
              </h3>
              <p className="text-slate-400" data-id="element-86">{step.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-brand-gold/20 to-brand-darker border border-brand-gold/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-87">
          <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-88">
            <ShieldCheck className="w-40 h-40 text-brand-gold" data-id="element-89" />
          </div>

          <div className="relative z-10" data-id="element-90">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-91">
              Lo que cambia en tus primeros 7 días
            </h3>
            <p className="text-xl text-slate-300 leading-relaxed max-w-3xl mx-auto" data-id="element-92">
              Pasarás de tener un perfil "fantasma" a recibir mensajes de
              personas calificadas. No prometemos que serás millonario mañana,
              pero sí garantizamos que{' '}
              <strong className="text-brand-gold" data-id="element-93">
                nunca más volverás a decir "no tengo a quién invitar al Zoom de
                esta noche".
              </strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}